module.exports = __webpack_public_path__ + "static/media/logo_cia_autismo.0d753129.png";